import Cookies from 'universal-cookie';

const AUTH_TOKEN_COOKIE = `js_auth_token`;

const AUTH_HEADER = `auth-token`;

const LOGOUT_PATH = '/user/logout';

const TRANSACTION_HEADER = 'transaction-id';

const SYSTEM_COOKIE = 'g4_syskey';

const SYSTEM_HEADER = 'g4-sys-key';

const LOGIN_PATH = '/welcome';

const SESSION_TIMEOUT_ERROR_PATH = '/error/session-expired';

const onLogout = () => {
  const cookies = new Cookies(document && document.cookie);
  cookies.remove(AUTH_TOKEN_COOKIE, { path: '/' });
};

const redirectToLogin = () => {
  window.location.replace(LOGIN_PATH);
};

const redirectToSessionTimeoutErrorPage = () => {
  window.location.replace(SESSION_TIMEOUT_ERROR_PATH);
};

const isLoginLink = link => link && link.path === LOGIN_PATH;
const isLogoutLink = link => link && link.path === LOGOUT_PATH;

const messageAuthErrorRegex = /Authentication needed/g;
const debugMessageAuthErrorRegex = /Authentication denied/g;

const isUnauthenticated = ({ debugMessage, message, locations, path }) => {
  return (
    messageAuthErrorRegex.test(message) ||
    debugMessageAuthErrorRegex.test(debugMessage)
  );
};

const extractTokens = () => {
  let cookies;
  if (typeof window !== 'undefined') {
    cookies = new Cookies(document && document.cookie);
  } else {
    cookies = new Cookies();
  }

  const authToken = cookies.get(AUTH_TOKEN_COOKIE);
  const transactionId = cookies.get(TRANSACTION_HEADER);
  const systemKey = cookies.get(SYSTEM_COOKIE);
  return {
    authToken,
    transactionId,
    systemKey,
  };
};

export {
  AUTH_TOKEN_COOKIE,
  AUTH_HEADER,
  LOGIN_PATH,
  LOGOUT_PATH,
  TRANSACTION_HEADER,
  SYSTEM_COOKIE,
  SYSTEM_HEADER,
  onLogout,
  isUnauthenticated,
  redirectToLogin,
  extractTokens,
  isLoginLink,
  isLogoutLink,
  redirectToSessionTimeoutErrorPage,
};
